import { useSearchParams } from 'react-router-dom'
import { NodeModel } from 'token/shared/types'

import { InteractionTaskNodeModel } from 'workflow/shared/types/processExecutionState.type'

export type ActionHandlerProps = {
  nodemodel?: NodeModel
  workflowUuid?: string
}

type ActionHandlerResponse = {
  url: string
  label: string
}

const useActionHandler = ({
  nodemodel,
  workflowUuid
}: ActionHandlerProps): ActionHandlerResponse => {
  const [searchParams] = useSearchParams()
  const hideInteractionContainer =
    searchParams.has('hideInteractionContainer') ?? false

  let url = ''

  if (nodemodel?.type === 'interaction_task_nodemodel') {
    const { interactionmodel_uuid } = (nodemodel as InteractionTaskNodeModel)
      .handler
    url = `/interaction/${workflowUuid}/${interactionmodel_uuid}${hideInteractionContainer ? `?hideInteractionContainer=true` : ''}`
  }

  return { url, label: nodemodel?.des ?? '' }
}

export default useActionHandler
